import "./Icons.scss";

function Close() {
  return (
    <svg viewBox="0 0 335.4 336.11" className="icon">
      <path d="M0,168.17C-.06,75.36,75.09,0,167.78,0,260.15,0,335.31,75.28,335.4,168c.08,92.17-75.09,168.19-166.28,168.15C75.19,336.06.06,261.45,0,168.17ZM150.79,168c-1.21,1.28-2.12,2.29-3.06,3.25q-19.32,19.65-38.64,39.26c-3.1,3.14-4.75,6.74-4,11.16A11.31,11.31,0,0,0,113.3,231c4.88,1.5,9.09.08,12.62-3.52q19.44-19.77,38.85-39.58c.93-.95,1.31-2.43,1.95-3.67a28.38,28.38,0,0,1,4.25,4q19.42,19.53,38.88,39c3,3,6.43,4.77,10.71,4.17a11.76,11.76,0,0,0,10.12-8.32c1.68-4.88.34-9.13-3.23-12.67q-20-19.78-40-39.52c-.94-.92-1.82-1.9-2.94-3.08,1.16-1,2-1.74,2.84-2.53,13-12.81,25.92-25.65,39-38.42,3-3,4.9-6.33,4.56-10.62a11.42,11.42,0,0,0-7.79-10.49c-4.91-1.83-9.35-.74-13,3q-19.76,19.72-39.45,39.51c-.94.94-1.92,1.83-3.18,3-1.18-1.34-2-2.43-3-3.4q-18.92-19-37.84-37.95c-3.33-3.35-7.22-4.94-11.87-3.8-9.31,2.27-12.24,13.39-5.31,20.4C123,140.28,136.77,153.92,150.79,168Z" />
    </svg>
  );
}

export default Close;
